import React, {memo} from 'react';
import {Button} from '@tickchak/react-share/app';
import * as css from './GeneratorSuggestions.css';

export interface GeneratorSuggestionsProps {
    suggestions: string[];
    onSuggestionClick: (text: string, index: number) => void;
}

function GeneratorSuggestions({suggestions, onSuggestionClick}: GeneratorSuggestionsProps) {
    return (
        <css.suggestionsStack>
            {suggestions.map((suggestion, index) => (
                <Button
                    customStyle={{fontWeight: 500}}
                    key={`${index}-${suggestion.slice(0, 16)}`}
                    onClick={() => onSuggestionClick(suggestion, index)}
                    data-testid={`generator-suggestion-${index}`}
                    size="category"
                >
                    {suggestion}
                </Button>
            ))}
        </css.suggestionsStack>
    );
}

export default memo(GeneratorSuggestions);
